// @ts-nocheck
import styled from 'styled-components';
import { getTheme } from 'settings/theme';
import type { StatelessFunctionalComponent } from 'react';

const {
  palette: { red, green, greyscale },
} = getTheme();
const FormInputWrapper: StatelessFunctionalComponent<any> = styled.div`
  margin-bottom: 1rem;
  width: 100%;

  .form-input {
    &__dollar-sign,
    &__percentage-sign {
      font-size: 1.6rem;
      line-height: 1.6rem;
      position: relative;
      top: 1.3rem;
    }

    &__dollar-sign {
      left: 2.2rem;
    }

    &__percentage-sign {
      left: 11.2rem;
    }

    &__input {
      position: relative;

      &--no-feedback {
        i {
          display: none;
        }

        input,
        textarea {
          outline: none;
          padding-left: 1.2rem;
          padding-right: 1.2rem;
          transition: none;
        }
      }

      i {
        font-size: 1.3rem;
        position: absolute;
        right: -1rem;
        opacity: 0;
        top: 50%;
        transform: translateY(-50%);
        transition: all 0.3s ease-in-out;
      }

      input,
      textarea {
        padding-left: 1.2rem;
        padding-right: 3rem;
        transition: none;
      }

      input.invalid,
      textarea.invalid {
        border: 1px solid ${red.default};
      }

      input.valid {
        border: 1px solid ${green.default};
      }

      input.invalid ~ i {
        color: ${red.default};
        opacity: 1;
        right: 1rem;

        :before {
          content: '\f057';
        }
      }

      input.valid ~ i {
        color: ${green.default};
        opacity: 1;
        right: 1rem;

        :before {
          content: '\f058';
        }
      }
    }

    &__input,
    &__input--no-feedback {
      input:focus,
      textarea:focus {
        border: 1px solid ${greyscale.black};
        box-shadow: none;
      }

      input:hover,
      textarea:hover {
        border: 2px solid ${greyscale.pewter};
        padding-left: 1.1rem;
        padding-right: 1.1rem;
      }
    }

    &__label-container {
      margin-bottom: 0.5rem;
    }

    &__label-container.text-counter {
      display: flex;
      justify-content: space-between;
    }

    &__label {
      margin: 0;
    }

    &__label.error {
      color: ${red.default};
      font-weight: 400;
    }
  }

  .has-data {
    input,
    textarea {
      border: 1px solid ${greyscale.black};
    }
  }

  .is-invalid {
    input,
    input:focus,
    input:hover,
    textarea,
    textarea:focus,
    textarea:hover {
      border: 2px solid ${red.default};
      padding-left: 1.1rem;
      padding-right: 1.1rem;
    }
  }

  .invalid-feedback {
    color: ${red.default};
    display: block;
    font-weight: 400;
  }

  .is-number {
    input {
      width: 10rem;
    }

    input::-webkit-inner-spin-button,
    input::-webkit-outer-spin-button {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
  }

  .percentage {
    input,
    input:focus {
      padding-right: 2.3rem;
    }

    input:hover {
      padding-right: 2.2rem;
    }
  }
`;
export default FormInputWrapper;
